import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import st from '@/components/SimpleToast';
import Image from 'next/image';
import { checkWeixin, checkIsApple, copyToClipboard } from '@/utils/utils';
import Apple from '@/components/Icon/Apple';
import GoogleIcon from '@public/images/common/google.svg';
import { handleGAType, handleGoShopType, DownloadSource } from '../../data';

interface IMobileBtn {
  handleGA: handleGAType;
  onClick: handleGoShopType;
  downloadSource?: DownloadSource;
}
const MobileBtn: React.FC<IMobileBtn> = ({ handleGA, downloadSource, onClick }) => {
  const { ios, wukongsch, androidWukong, android } = downloadSource || {};
  const { t } = useTranslation('download');
  const isApple = checkIsApple();

  const wukongDownloadUrl = useMemo(() => {
    return `${wukongsch}download`;
  }, [wukongsch]);

  const copyLink = useCallback(
    (link?: string, traceName?: string) => {
      if (!link) return;
      copyToClipboard(link).then(() => {
        st.showToast(t('复制成功'));
      });
      handleGA(traceName);
    },
    [handleGA, t],
  );

  const getWeixinTips = useCallback(
    (tipsText: string) => {
      return (
        <>
          <div className="mt-2 text-center text-[18px] font-extrabold leading-6">{tipsText}</div>
          <a
            className="mb-4 mt-2 block text-[16px]"
            onClick={() => copyLink(wukongDownloadUrl, 'O_APPDownload_CopyDownloadLinkClick')}
          >
            {wukongDownloadUrl}
          </a>
          <div
            className="justify-centerr relative mb-5 flex w-full cursor-pointer justify-center rounded-full bg-black px-6 py-3 text-white"
            onClick={() => copyLink(wukongDownloadUrl, 'O_APPDownload_CopyDownloadLinkClick')}
          >
            <div className=" text-[18px] font-bold">{t('复制下载链接')}</div>
          </div>
        </>
      );
    },
    [copyLink, t, wukongDownloadUrl],
  );
  if (isApple) {
    if (checkWeixin()) {
      return getWeixinTips(t('前往App Store搜索 WuKong 或使用默认浏览器打开'));
    }
    return (
      <div
        className="relative mb-5 flex w-full cursor-pointer items-center justify-center rounded-full bg-black px-1 py-3 text-white"
        onClick={() => onClick(ios, 'O_APPDownload_AppleStoreClick')}
      >
        <Apple className="mr-2 h-6 w-6 xl:mr-3" fill="white" />
        <div
          className=" text-[18px] font-bold [&>strong]:font-bold"
          dangerouslySetInnerHTML={{ __html: t('App Store 下载') }}
        />
      </div>
    );
  }
  if (checkWeixin()) {
    return (
      <>
        {getWeixinTips(t('前往Google Play搜索 WuKong 或使用默认浏览器打开'))}
        <a
          onClick={() => onClick(androidWukong, 'O_APPDownload_AndroidApkClick')}
          className="mb-5 block text-center text-[16px] underline underline-offset-4"
        >
          {t('下载安装包')}
        </a>
      </>
    );
  }
  return (
    <>
      <div
        className="justify-centerr relative mb-5 flex w-full cursor-pointer justify-center rounded-full bg-black px-6 py-4 text-white"
        onClick={() => onClick(android, 'O_APPDownload_AndroidGooglePlayClick')}
      >
        <Image className="relative mr-2 h-6 w-6" alt="" width={40} height={40} src={GoogleIcon} quality={100} />
        <div
          className=" text-[16px] font-bold [&>strong]:font-bold"
          dangerouslySetInnerHTML={{ __html: t('Google Play 下载') }}
        />
      </div>
      <a
        onClick={() => onClick(androidWukong, 'O_APPDownload_AndroidApkClick')}
        className="mb-5 block text-center text-[16px] underline underline-offset-4"
      >
        {t('下载安装包')}
      </a>
    </>
  );
};

export default MobileBtn;
